<template>
  <div class="product-type">
    <section class="for-outgoing">
      <div class="product-header">
        <span>たくさんの人に</span><br />
        <span class="header-bold">コールしたい!!</span>
      </div>
      <div style="width: 100%; text-align: center;">
        <img
          class="product-image"
          v-lazy="'/static/purposes/outgoing.png'"
          alt="たくさんの人にコールしたい"
        />
      </div>
      <ul class="product-items">
        <li v-for="(item, index) in outgoingItems" :key="index">
          <product-item-appeal
            v-bind:name="item.name"
            v-bind:productName="item.productName"
            v-bind:title="item.title"
            v-bind:appeal="item.appeal"
            v-bind:detail="item.detail"
          />
        </li>
      </ul>
    </section>

    <section class="for-incoming">
      <div class="product-header">
        <span>たくさんの人や設置場所から</span><br />
        <span class="header-bold">コールを受けたい!!</span>
      </div>
      <div style="width: 100%; text-align: center;">
        <img
          class="product-image"
          v-lazy="'/static/purposes/incoming.png'"
          alt="たくさんの人や設置場所からコールを受けたい"
        />
      </div>
      <ul class="product-items">
        <li v-for="(item, index) in incomingItems" :key="index">
          <product-item-appeal
            v-bind:name="item.name"
            v-bind:productName="item.productName"
            v-bind:title="item.title"
            v-bind:appeal="item.appeal"
            v-bind:detail="item.detail"
          />
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import ProductItemAppeal from '@/components/modules/ProductItemAppeal'

export default {
  components: {
    ProductItemAppeal,
  },
  data() {
    return {
      outgoingItems: [
        {
          name: 'remote-reply-call',
          productName: 'リモートリプライコール',
          title: '数キロ先の長距離範囲を呼び出したい',
          appeal: '文字メッセージで広範囲に連絡できます。',
          detail: `32文字までのメッセージを
          送信できます。`,
        },
        {
          name: 'remote-reply-call-pc',
          productName: 'リモートリプライコールPC',
          title: '数キロ先の長距離範囲をパソコンから呼び出したい',
          appeal: 'マウス / タッチパネルの簡単操作で呼出状況を管理できます︕',
          detail: `わかりやすいアイコン表示で、
          お知らせ漏れの心配が
          ありません。`,
        },
        {
          name: 'reply-call',
          productName: 'リプライコール',
          title: '順番や時間が来たら呼び出したい',
          appeal: '広い場所や異なるフロアーには中継機で対応できます。',
          detail: `AC電源はもちろん
          電池駆動で屋外でも
          活用可能。`,
        },
        {
          name: 'reply-call-pc',
          productName: 'リプライコール PC',
          title: 'パソコンから呼び出したい',
          appeal: 'リプライコールをパソコンから操作・管理することができます。',
          detail: `PC/ タブレットから
          登録コードを
          ワンタッチで送信。`,
        },
      ],
      incomingItems: [
        {
          name: 'beyond-ec',
          productName: 'ビヨンドイーシー',
          title: 'より機能的で、より便利に連絡を受けたい',
          appeal: `電池レス特定小電力無線とWi-Fi を組み合わせた
          「新・呼び出しシステム」︕`,
          detail: `Android スマホが
          そのままレシーバーに︕`,
        },
        {
          name: 'eco-chime',
          productName: 'エコチャイム',
          title: 'お客様からの注文や呼び出しの連絡を受け取りたい',
          appeal: `チャイムをプッシュで、掲示板に呼び出し番号を表示したり、
          受信機で呼び出しの連絡を受けることができます。`,
          detail: `電池を使わない
          革新的なチャイム。`,
        },
        {
          name: 'coco-call',
          productName: 'コココール',
          title: 'お客様からの注文や会計の連絡を受け取りたい',
          appeal: '',
          detail: `送信機ごとに
          チャイム音を設定！
          防沫構造で水洗いも可能。`,
        },
        {
          name: 'fact-in-call',
          productName: 'ファクトインコール',
          title: '工場や倉庫内のトラブル時に連絡をすぐに受けたい',
          appeal: `センサーと連動させて生産ラインや搬送ラインの監視箇所に設置し、
          トラブル時に連絡を受けることができます。`,
          detail: `工場ラインの安定稼働
          大幅な省力化を実現。`,
        },
      ],
    }
  },
}
</script>

<style scoped>
.product-image {
  display: inline-block;

  width: auto;
  height: 200px;
  margin: 30px 0 10px 0;
}

.for-outgoing,
.for-incoming {
  margin: 0;
}

.product-image {
  width: 70%;
  max-width: 400px;
  height: auto;
  margin: 30px auto 10px auto;
}

.product-item-appeal {
  width: 80%;
  margin: 0 auto;
}

.header-bold {
  font-size: 30px;
}

.product-type {
  flex-direction: column;
}

.product-header {
  float: none;

  width: 100%;
  padding: 0;
}

.product-items {
  float: none;

  width: auto;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/choice/SpChoiceByPurpose.vue